<template>
  <template v-for="item in items.filter(isDefined)" :key="item.sys.id">
    <LibErrorBoundary component-name="MappedComponent" :child-props="item">
      <LazyIdleMappedComponent hydrate-on-idle :item="item" />
    </LibErrorBoundary>
  </template>
</template>

<script setup lang="ts">
import type { Entry } from '~~/lib/Contentful/types';
import { isDefined } from '~/utils/guards/isDefined';

interface Props {
  items: ReadonlyArray<Entry<unknown>>;
}

defineProps<Props>();
</script>
